import { z } from 'zod';

export const rejectFiscalDocumentSchema = z.object({
  rejection_reason: z.string().min(1, 'Campo obrigatório'),
});

export type RejectFiscalDocumentValidationSchema = z.infer<typeof rejectFiscalDocumentSchema>;
